import { useMutation } from "@tanstack/react-query";
import { service, useAuthConfig } from "@theprelude/core";
import { CreateViewParams, UpdateViewParams } from "@theprelude/sdk";

export function useCreateView() {
  const authConfig = useAuthConfig();

  return useMutation({
    mutationFn: (params: CreateViewParams) => {
      return service(authConfig).scm.createView(params);
    },
  });
}

export function useUpdateView() {
  const authConfig = useAuthConfig();

  return useMutation({
    mutationFn: (params: UpdateViewParams) => {
      return service(authConfig).scm.updateView(params);
    },
  });
}

export function useDeleteView() {
  const authConfig = useAuthConfig();

  return useMutation({
    mutationFn: (viewId: string) => {
      return service(authConfig).scm.deleteView(viewId);
    },
  });
}
